goog.provide('el8.appchart.visitNote.billDialogMgr');

goog.require('el8.app.shared.dialog.billingInfoDialog');

goog.require('el8.util.consts');

/**
 * A module for making external calls into the bill dialogs
 * without having to keep track of whether you should be
 * talking to the ICD-9 or ICD-10 dialog.
 */
el8.appchart.visitNote.billDialogMgr = (function() {

    var that = {};

    that.isOpen = function() {
        return el8.app.shared.dialog.billingInfoDialog.isOpen();
    };

    /*
     * We default to showing the ICD10 dialog, but we'll show the
     * old dialog for any bills with unstructured DXs
     */
    that.show = function(spec) {
        spec = spec || {};
        that.hide();

        var note = spec.visitNote;

        // Alert to user that Bill dialog is opening, in the case that the process hangs
        el8.appservice.notifier.notify('Opening bill...');

        // Show BillingInfoDialog (Bill 2.0)
        el8React.dispatch.openBillingInfoDialog({patientId: el8Globals.PATIENT_ID, source: spec.source, visitNoteId: note.rawData.id});
    };
    that.hide = function() {
        el8React.dispatch.closeBillingInfoDialog();
    };

    /*
     * We should not have both version of the dialog open at once,
     * but if we do, we'll prioritize the icd10 dialog
     */
    that.appendCpt = function(cptCode, parsedCodeArr) {
        if (el8.app.shared.dialog.billingInfoDialog.isOpen()) {
            var payload = { cptCode: cptCode, codeModifiers: parsedCodeArr };
            el8React.messenger.send('BillingAddProcedure', { type: 'BillingAddProcedure', payload: payload });
        }
    };


    /**
     * codeIdSpec can contain a list of `imoIds` or `icd9Ids`.
     * icd9Ids will only be relevant to the to the billDialogIcd9.
     * imoIds will be relevant to the visit note and billDialogIcd10.
     *
     * We can eventually add icd10Ids when we have a complete ICD-10 DB
     * and can accept ICD-10s outside the context of IMOs.
     *
     * @param {object} codeIdSpec
     * @param {string[]} codeIdSpec.imoIds - List of IMO vendor code IDs
     */
    that.appendDiagnoses = function(codeIdSpec, opts) {
        if (el8.app.shared.dialog.billingInfoDialog.isOpen()) {
            // Sync ImoCodes from legacy to ensure order of add/import DX
            var imoCodes = [];

            // FUTURE: Refactor with explicit list of ICD-10 codes to avoid possible IMO-to-ICD10 stale cache
            if (codeIdSpec && codeIdSpec.imoIds) {
                codeIdSpec.imoIds.forEach(function (imoId) {
                    var imo = el8.data.imos.getByIdIncludingDeleted(imoId);
                    if (imo && imo.rawData) {
                        imoCodes.push(Object.assign({}, imo.rawData));
                    }
                })
            }

            var payload = Object.assign({imoCodes: imoCodes}, codeIdSpec, opts);
            el8React.messenger.send('BillingAddDiagnosis', { type: 'BillingAddDiagnosis', payload: payload });
        }
    };

    /**
     * Remove ICD-10 codes from billing draft for sync'ing Assessments to Bill 2.0.
     *
     * @param {object} codeIdSpec
     * @param {string[]} codeIdSpec.icd10Codes - List of ICD-10 codes, e.g. ["R05.3", "R05.9"]
     */
    that.removeDiagnoses = function (codeIdSpec) {

        if (!el8.app.shared.dialog.billingInfoDialog.isOpen()) { return; }
        if (!codeIdSpec || !codeIdSpec.icd10Codes) { return; }

        var payload = Object.assign({}, codeIdSpec);
        el8React.messenger.send('BillingRemoveDiagnosis', { type: 'BillingRemoveDiagnosis', payload: payload });
    }

    return that;

})();
